import { PropertyId } from "./PropertyId";
import { PID_TEXT_CONTENT, PID_FONT_SIZE, PID_RECT_WIDTH, PID_RECT_HEIGHT, PID_CIRCLE_RADIUS, PID_SHOW_AREA_TEXT, PID_EXTRUSION_DEPTH, PID_SHOW_VOLUME } from "./PropertyIds";

// Name/description text lives in this resource table keyed by PropertyId, not on the property
// item itself, so the same id resolves to the same label everywhere it's used.
const nameResourceKeys: Record<PropertyId, string> = {
    [PID_TEXT_CONTENT]: 'properties.field.textContent.name',
    [PID_FONT_SIZE]: 'properties.field.fontSize.name',
    [PID_RECT_WIDTH]: 'properties.field.rectWidth.name',
    [PID_RECT_HEIGHT]: 'properties.field.rectHeight.name',
    [PID_CIRCLE_RADIUS]: 'properties.field.circleRadius.name',
    [PID_SHOW_AREA_TEXT]: 'properties.field.showAreaText.name',
    [PID_EXTRUSION_DEPTH]: 'properties.field.extrusionDepth.name',
    [PID_SHOW_VOLUME]: 'properties.field.showVolume.name',
};

export function getPropertyNameKey(id: PropertyId): string {
    return nameResourceKeys[id] ?? id;
}
